export type DownloadIPRights = "DOWNLOAD_IP_RIGHTS";
export const DOWNLOAD_IP_RIGHTS: DownloadIPRights = "DOWNLOAD_IP_RIGHTS";
